<template>
  <button
    v-if="editorAvailable"
    type="button"
    class="btn btn-link p-0 align-baseline text-start pool-link"
    @click="launcher.open(poolId)"
  >
    <slot />
  </button>
  <span v-else><slot /></span>
</template>

<script setup lang="ts">
import { usePoolEditorAvailable } from "@/forwards2/components/poolEditorAvailability";
import { usePoolEditorLauncher } from "@/forwards2/pools/usePoolEditorLauncher";

/**
 * A pool's name that opens the pool editor in place, on whichever page it is shown. The page mounts
 * a `PoolEditorModalHost`, which the launcher drives; a page that cannot open the editor says so
 * (`providePoolEditorAvailable`) and the name is shown alone.
 */
defineProps<{
  poolId: number;
}>();

const launcher = usePoolEditorLauncher();
const editorAvailable = usePoolEditorAvailable();
</script>

<style scoped lang="scss">
// Reads as the inline link it replaces, not as a button.
.pool-link {
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  text-decoration: none;
}
</style>
